import React, { useState, useEffect, useRef } from "react";
import "../../assets/css/candidate-tab-form.css";
import _ from "lodash";
import "../../assets/css/inner-tabs.css";
import TickIconBlack from "../../assets/img/tick-icon-black.png";
// import CrossIcon from '../assets/img/cross-icon.png';
import UploadIcon from "../../assets/img/upload-icon.svg";
import ExclamationIcon from "../../assets/img/exclamation-mark-icon.svg";
// import ArrowRightIcon from '../assets/img/arrow-right-icon.png';
// import InputFieldEducation from "./InputFieldEducation";

import { getData } from "../../Actions/landingAction";
//this is import just to grab upload file functionality
import { uploadFileViaMultipart } from "../../Actions/personalDetailsActions";
import ABSelect from "../Common/ABSelect";
import EDUCheckbox from "./eduCheckbox";
import EduSimpleSelect from "./eduSimpleSelect";
import Loader from "../Common/loader";
import { dateFormat } from "../../Helper/common";
import { dateFormat2 } from "../../Helper/common";
import { toast } from "react-toastify";
import {
  getEducation,
  addEducation,
  removeEducation,
  saveEducation,
  deleteSaveEducation,
  getMRLDocument,
  fetchStateUniversity,
} from "../../Actions/educationActions";
import { useDispatch, useSelector } from "react-redux";
import GetMasterData from "../../Helper/masterData";
import ABYear from "../Common/ABYear";
import ABDate from "../Common/ABDate";
import ABMonthYear from "../Common/ABMonthYear";
import ABUploadEdu from "../Common/ABUploadEdu";
import ABUploadEdu2 from "../Common/ABUploadEdu2";
import ABUploadEdu3 from "../Common/ABUploadEdu3";
import ABTextEdu from "../Common/ABTextEdu";
import ABCarousel from "../ABCarousel";
import "../../assets/css/custom-modal.css";
import "../../assets/css/rec-carousel.css";
import CustomPopUp from "../Common/customPopUp";
import { getCarousel } from "../../Actions/carouselAction";
import { useNavigate, useHistory } from "react-router-dom";
import ConfirmationPopup from "./confirmationPopup";
import RadioEducation from "./RadioEducation";
import { getMasterUniversityEducation } from "../../Actions/DigiLockerActions";
import SearchableDropdown from "./SearchableDropdown";
import ABYearEdu from "../Common/ABYearEdu";
import ABSelectEduLocation from "../Common/ABSelectEduLocation";
// import { Delete_Icon } from "../../assets/img/Delete_Icon.svg";

const MainFormNewEducation = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const eduRef = useRef();

  const handleScroll = () => {
    const formGroup = eduRef?.current.querySelector('.form-group:has(.err)');
    debugger
    if (formGroup?.firstElementChild && false) {
      const erroField = formGroup.firstElementChild
      if (erroField) {
        erroField.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
      }
    } else {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    }
  }


  const {
    edu,
    active,
    reference,
    showAddPopup,
    setShowAddPopup,
    closeAddPopup,
    checkStatus,
  } = props;
  //alert(active);

  const [isLoading, setIsLoading] = useState(false);
  const [checked, setChecked] = React.useState(false);
  const [education, setEducation] = useState([]);
  //state used for form fields
  const [formVal, setFormVal] = useState({});
  const [formError, setFormError] = useState({});
  const [MRLDoc, setMRLDoc] = useState([]);
  const [caseCheckIdAddEdu, setCaseCheckIdAddEdu] = useState();
  const [indexAddEdu, setIndexAddEdu] = useState();
  //state used for custom form fields that is formatted for sending data as per the api
  const [checkDataRecord, setCheckDataRecord] = useState({});

  const [otherInstituteObj, setOtherInstituteObj] = useState({
    // value: "",
    // isError: false,
    // isVisible: false,
  });
  const storeMRLDocument = useSelector((state) => state.MRLDocument || {});
  const {
    MRLDocumentData,
    loading: Loading,
    error: saveErr,
  } = storeMRLDocument;

  // useEffect(() => {
  //   if (
  //     typeof MRLDocumentData?.data !== "undefined" &&
  //     MRLDocumentData?.data !== null
  //   ) {
  //       setMRLDoc(MRLDocumentData?.data.required_documents);
  //   }
  // }, [MRLDocumentData]);

  const [newRecord, setNewRecord] = useState({});
  const [newValidationRecord, setNewValidationRecord] = useState({});

  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(0);
  const [maxDate, setMaxDate] = useState(null);
  const [errorMessage, setErrorMessage] = useState(false);
  //setting state for checkox
  // const handleChange = () => {
  //   setChecked(!checked);
  // };
  const [showRemovePopup, setShowRemovePopup] = useState(false);
  const [checkIdToBeRemoved, setCheckIdToBeRemoved] = useState(null);
  const [mrlDocList, setMRLDocList] = useState([]);
  const [add, setAdd] = useState(0);

  // const [address, setAddress] = useState([]);
  //  new form states
  const [showCountry, setShowCountry] = useState(0);
  const [allInitialDisable, setAllInitialDisable] = useState(false);
  const [disableUniv, setDisableUniv] = useState(false);
  const [disableCollege, setDisableCollege] = useState(false);
  const [stateBasedUniOptions, setStateBasedUniOptions] = useState({});
  const [uniOptionValue, setUniOptionValue] = useState({});
  const [otherUniv, setOtherUniv] = useState({});
  const initialRef = useRef(false);

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }

  const handleChange = (value) => {
    setChecked(!checked);

    console.log("val", value);

    //  setTillDateChecked(value[0].value);

    //console.log("check"+value[0].value);

    // const { dataset, value } = checkboxValues;

    // if (dataset.fieldname === "till_date") {
    //   let updatedTillDateChecked = _.cloneDeep(tillDateChecked);
    //   const updatedValue =
    //     updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] === true
    //       ? ""
    //       : "checked";

    //   updatedTillDateChecked[parseInt(dataset.checkdetailsindex)] = !updatedTillDateChecked[parseInt(dataset.checkdetailsindex)];
    //   setTillDateChecked(updatedTillDateChecked);

    //    updateAddressDetails(dataset, updatedValue);
    // }

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    // if (dataset.fieldname === "no_ssn") {
    //   let updatedNoSsn = _.cloneDeep(noSsnChecked);
    //   const updatedValue =
    //   updatedNoSsn[parseInt(dataset.checkdetailsindex)] === true
    //       ? ""
    //       : "checked";

    //   updatedNoSsn[parseInt(dataset.checkdetailsindex)] = !updatedNoSsn[parseInt(dataset.checkdetailsindex)];
    //   setNoSsn(updatedNoSsn);
    //   let scotDetails = _.cloneDeep(scotDisclosure);
    //   scotDetails.checksDetails[0].fields['ssn'].is_mandatory = 0;
    //   setScotDisc(scotDetails);
    // }

    updateEduDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
  };

  const [uploadedFilesCount, setUploadedFilesCount] = useState({});
  const [documnetMandatory, setDocumnetMandatory] = useState({});
  const [required_documents, setRequired_documents] = useState({});

  //setting education data
  useEffect(() => {
    console.log("check", edu);

    if(edu && edu.checksDetails){
      Object.entries(edu?.checksDetails).map(([key, value]) => {
        if(value?.fields?.['edu_institue_country'] && !value?.fields?.['edu_institue_country']?.field_value){
          value.fields['edu_institue_country'].field_value = 'india'
          setShowCountry((prev) => ({
            ...prev,
            [activeTab]: 0,
          }));
        }
      })
    }
    
    console.log(edu, 'eddu');

    setEducation(edu);
    setCatchIfAnyStatusIsNotCompleted(0);

    const checksDetails = edu.checksDetails;

    getUploadedFilesCount(checksDetails);
    getDocumentIdMandatory(checksDetails);
    // getMRLDocList(checksDetails);
  }, [edu]);

  useEffect(() => {
    getMRLDocList(edu?.checksDetails);
  }, [edu?.checksDetails]);

  // getting values to show in dropdowns
  const {
    degreeOptions,
    veridficationCourseNameOptions,
    qualificationOptions,
    modeOfQualificationOptions,
    stateOptionsEducation,
  } = GetMasterData();

  //function to re-rener component
  const reRenderAgain = () => {
    props.reRenderAgain(education);
  };

  const reRenderAgain2 = () => {
    props.reRenderAgain2();
  };

  const proceedAdd = (e) => {
    let isadd = 1;
    saveHandler(e, caseCheckIdAddEdu, indexAddEdu, isadd);
    setShowAddPopup(false);
  };

  const updateEduDetails = (dataset, name, value, optionVal) => {
    // alert(value);
    let eduDetails = _.cloneDeep(education);
    eduDetails.checksDetails[parseInt(dataset)].fields[name].field_value =
      value;
    // clearing value of college field on changing university
    if (name == "university_board" && optionVal) {
      eduDetails.checksDetails[parseInt(dataset)].fields[
        "verificationName_" + optionVal
      ].field_value = "";
      setOtherInstituteObj((prev) => ({
        ...prev,
        [activeTab]: {
          value: "",
          isError: false,
          isVisible: false,
        },
      }));
      eduDetails.checksDetails[parseInt(dataset)].verification_source_name = '';
      eduDetails.checksDetails[parseInt(dataset)].verification_source_id = '';
      eduDetails.checksDetails[parseInt(dataset)].verificationName = ''
      document.getElementById("cis_" + eduDetails.checksDetails[parseInt(dataset)].case_check_id).value = '';
      if(value != 'other'){
        eduDetails.checksDetails[parseInt(dataset)].fields['university_board_other'].field_value = ""
      }
    }
    // setting courseVerification value
    if (name == "course_name") {
      eduDetails.checksDetails[parseInt(dataset)].fields[name].option_value =
        optionVal;
    }
    console.log("ee", eduDetails);
    setEducation(eduDetails);
    // console.log("ee", education);

    // let details = _.cloneDeep(address);
    // if(details.checksDetails[parseInt(dataset)]&&details.checksDetails[parseInt(dataset)].fields){
    // details.checksDetails[parseInt(dataset)].fields[name].field_value = value;
    // console.log("ee", details);
    // setAddress(details);
    // }
  };

  //cheking if any status is not completed
  const [catchIfAnyStatusIsNotCompleted, setCatchIfAnyStatusIsNotCompleted] =
    useState(0);
  useEffect(() => {
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      Object.entries(education.checksDetails).map(([key, value]) => {
        if (value.check_status === 2 || value.check_status === 3) {
          setCatchIfAnyStatusIsNotCompleted(0);
        } else {
          setCatchIfAnyStatusIsNotCompleted(1);
        }
      });
    }
  }, [education]);

  // useEffect(() => {
  //   if (education && education?.checksDetails && stateOptionsEducation.length > 0 ) {
  //     let value =
  //       education?.checksDetails?.[activeTab]?.fields["course_name"];
  //     if (value && value?.field_value && !value?.option_value) {
  //       let id = "";
  //       stateOptionsEducation.map((option, i) => {
  //         if (option.label == value?.field_value) {
  //           id = option.value;
  //         }
  //       });

  //     let eduDetails = _.cloneDeep(education);
  //     eduDetails.checksDetails[activeTab].fields['course_name'].option_value = id;
  //     setEducation(eduDetails);
  //     console.log('1111' ,eduDetails)
  //   }
  //   }
  // }, [activeTab, stateOptionsEducation]);

  const getUploadedFilesCount = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        let count = 0;
        for (let k in checksDetails[i].uploaded_documents) {
          if (
            checksDetails[i].uploaded_documents[k].document_id ==
            checksDetails[i].required_documents[j].id
          ) {
            count++;
          }
        }
        obj[`${checksDetails[i].required_documents[j].id}`] = count;
      }
      const MRLRequiredDocs = MRLDocumentData
        ? MRLDocumentData[checksDetails[i]?.case_check_id]?.required_documents
        : null;
      if (MRLRequiredDocs?.length) {
        for (let j in MRLRequiredDocs) {
          let count = 0;
          for (let k in checksDetails[i].uploaded_documents) {
            if (
              checksDetails[i].uploaded_documents[k].document_id ==
              MRLRequiredDocs[j].id
            ) {
              count++;
            }
          }
          obj[`${MRLRequiredDocs[j].id}`] = count;
        }
      }
      uploadedFilesCount[i] = obj;
    }
    setUploadedFilesCount(uploadedFilesCount);
  };

  //alert(JSON.stringify(uploadedFilesCount));

  const getDocumentIdMandatory = (checksDetails) => {
    let uploadedFilesCount = {};
    for (let i in checksDetails) {
      let obj = {};
      for (let j in checksDetails[i].required_documents) {
        obj[
          `${checksDetails[i].required_documents[j].id}`
        ] = `${checksDetails[i].required_documents[j].is_mandatory}`;
      }
      const MRLRequiredDocs = MRLDocumentData
        ? MRLDocumentData[checksDetails[i].case_check_id]?.required_documents
        : null;
      if (MRLRequiredDocs?.length) {
        for (let j in MRLRequiredDocs) {
          obj[
            `${MRLRequiredDocs[j].id}`
          ] = `${MRLRequiredDocs[j].is_mandatory}`;
        }
      }
      uploadedFilesCount[i] = obj;
    }

    //alert(JSON.stringify(uploadedFilesCount));
    setDocumnetMandatory(uploadedFilesCount);

    //setRequired_documents
  };

  //alert(JSON.stringify(documnetMandatory));

  //for getting the info of fields taht is formatted as per the api format
  const textHandler = (value) => {
    console.log("fr", value);
    if (
      value[0].fieldname == "roll_no" ||
      value[0].fieldname == "grade_percentage"
    ) {
      //console.log("true");
      if (value[0].value.trim() == "") {
        value[0].value = "";
      }
    }
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    //alert(JSON.stringify(value));

    if(value[0].fieldname == "university_board"){
      setDisableCollege(false);
    }

    updateEduDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
  };

  //for getting the info of fields taht is formatted as per the api format
  const selectHandler = (value) => {
    console.log("fr", value);
    if (value[0].fieldname == "extra_remarks") {
      //console.log("true");
      if (value[0].value.trim() == "") {
        value[0].value = "";
      }
    }
    // alert(JSON.stringify(value))
    if(value[0]?.fieldname != "university_board_other" && value[0]?.fieldname != `verificationName_${value[0]?.caseCheckId}`){
      var cols = document.getElementById(value[0].err_id);
      cols.innerHTML = "";
    }
    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));

    //this is state is for validation purpose

    //alert(JSON.stringify(value));

    if(value[0].fieldname == 'university_board_other'){
      setOtherUniv((prev) => ({
        ...prev,
        [value[0].checkdetailsindex] : { value: value[0].value, isError: false, isVisible: true }
      }))
    }

    if (value[0].fieldname == "university_board_generic") {
      updateEduDetails(
        value[0].checkdetailsindex,
        "university_board",
        value[0].value,
        value[0].caseCheckId
      );

      if (value[0].value == "other") {
        setOtherUniv((prev) => ({
          ...prev,
          [value[0].checkdetailsindex]: {
            value: "",
            isError: false,
            isVisible: true,
          },
        }));
      } else {
        setOtherUniv((prev) => ({
          ...prev,
          [value[0].checkdetailsindex]: {
            value: "",
            isError: false,
            isVisible: false,
          },
        }));
      }
      setDisableCollege(false);
      setUniOptionValue((prev) => ({
        ...prev,
        [value[0].checkdetailsindex]: value[0].optionValue,
      }));
    } else if (value[0].fieldname == "course_name") {
      updateEduDetails(
        value[0].checkdetailsindex,
        value[0].fieldname,
        value[0].value,
        value[0].optionValue
      );
    } else {
      updateEduDetails(
        value[0].checkdetailsindex,
        value[0].fieldname,
        value[0].value
      );
    }

    // updateEduDetails(value[0].checkdetailsindex, value[0].fieldname, value[0].value)
  };

  //on tab change set data for editing
  const tabChange = (index, caseCheckId) => {
    // alert("d");

    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      if (caseCheckId) {
        // reRenderAgain();
        navigate(`/case-initiation/check-detail/${reference}/3/${caseCheckId}`);
        //reRenderAgain();
      }

      Object.entries(education.checksDetails[index].fields).map(
        ([key, value]) => {
          setNewRecord((prevState) => ({
            ...prevState,
            [value.id]: value.field_value,
          }));

          if (value.id == 52) {
            setChecked(value.field_value == 1 ? true : false);
          }
        }
      );
      // setOtherInstituteObj((prev) => ({
      //   ...prev,
      //   [index] : {value:'',isError:false,isVisible:false}
      // }))
      // setOtherUniv((prev) => ({
      //   ...prev,
      //   [index] : {value:'',isError:false,isVisible:false}
      // }))
      setActiveTab(index);
    }
  };

  //select option handler for getting non select handler
  const selectHandler2 = (value) => {
    const ob = { ...otherInstituteObj };
    ob.isVisible = false;
    if (value[0].value == "other") {
      ob.isVisible = true;
      setOtherInstituteObj((prev) => ({
        ...prev,
        [value[0].checkdetailsindex]: {
          value: "",
          isError: false,
          isVisible: true,
        },
      }));
    } else {
      setOtherInstituteObj((prev) => ({
        ...prev,
        [value[0].checkdetailsindex]: {
          value: "",
          isError: false,
          isVisible: false,
        },
      }));
    }
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  console.log(otherInstituteObj, "oth");

  const updateOtherInstitute1 = (value) => {
    const custumUniversityName = value[0].value;
    const ob = { ...otherInstituteObj };
    ob.value = custumUniversityName;
    setOtherInstituteObj(ob);
    // var cols = document.getElementById(value[0].err_id);
    // cols.innerHTML = "";
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  const updateOtherInstitute = (value) => {
    const custumUniversityName = value[0].value;
    const ob = { ...otherInstituteObj };
    // ob.value = custumUniversityName;
    if (value[0].value != "") {
      ob.isError = false;
    }
    setOtherInstituteObj((prev) => ({
      ...prev,
      [value[0].checkdetailsindex]: {
        value: custumUniversityName,
        isError: false,
        isVisible: true,
      },
    }));
    // setOtherInstituteObj(ob);
    // var cols = document.getElementById(value[0].err_id);
    // cols.innerHTML = "";
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  var initialflag = false;
  console.log(allInitialDisable , 'dis')

  useEffect(() => {
    if (
      education &&
      education?.checksDetails?.[activeTab]?.fields.edu_institue_country
        // .field_value == ""
    ) {
      // setAllInitialDisable((prev) => ({
      //   ...prev,
      //   [activeTab] : true
      // }))
      // if(showCountry[activeTab])
      if(!education?.checksDetails?.[activeTab]?.fields?.['edu_institue_state']?.field_value && education?.checksDetails?.[activeTab]?.fields.edu_institue_country.field_value == 'india')
      setDisableUniv((prev) => ({
        ...prev,
        [activeTab] : true
      }))
      if(!education?.checksDetails?.[activeTab]?.fields?.['university_board']?.field_value)
      setDisableCollege((prev) => ({
        ...prev,
        [activeTab] : true
      }))
    }
  }, [education?.checksDetails?.[activeTab]?.fields?.edu_institue_country, activeTab]);

  //on intial load  set data for editing in first tab
  useEffect(() => {
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      console.log("sdsdsd");
      //finding which tab is active
      let activeTab = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          activeTab = tabs[i].dataset.index;
        }
      }

      setNewRecord({});

      if (activeTab == 0) {
        //reRenderAgain()
        Object.entries(education.checksDetails[0].fields).map(
          ([key, value]) => {
            setNewRecord((prevState) => ({
              ...prevState,
              [value.id]: value.field_value,
            }));

            if (value.id == 52) {
              setChecked(value.field_value == 1 ? true : false);
            }
            // check if country is india or not
            if(value.id == 580 ){
              if(value.field_value){
                setShowCountry((prev) => ({
                  ...prev,
                  [activeTab]: value.field_value == 'india' ? 0 : 1,
                }));
              }
          }
          }
        );

        // setOtherInstituteObj((prev) => ({
        //   ...prev,
        //   '0' : {value:'',isError:false,isVisible:false}
        // }))
        // setOtherUniv((prev) => ({
        //   ...prev,
        //   '0' : {value:'',isError:false,isVisible:false}
        // }))

        // Setting all disabled in the initial form
        // if(education.checksDetails[0].fields.edu_institue_country && !initialflag ){
        //   setAllInitialDisable(true);
        //   setDisableUniv(true);
        //   setDisableCollege(true);
        //   initialflag = true;
        // }
      }
    }
    let today = new Date();
    setMaxDate(today);
  }, [education, active]);

  useEffect(() => {
    if(typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null && activeTab){
        let field = education?.checksDetails?.[activeTab]?.fields['edu_institue_university_id'];
        if(field?.field_value && !uniOptionValue[activeTab]){
          setUniOptionValue((prev) => ({
            ...prev,
            [activeTab] : field?.field_value
          }))        
        }
        let verName = education?.checksDetails[activeTab]?.verificationName;
        let verSource = education?.checksDetails[activeTab]?.verification_source_id;
        let verText = education?.checksDetails[activeTab]?.verification_source_name;
        let collegeVal = education?.checksDetails[activeTab]?.fields[`verificationName_${education?.checksDetails[activeTab]?.case_check_id}`].value;
        
        if(verName && verText && collegeVal == 'other'){
          setOtherInstituteObj((prev) => ({
              ...prev,
              [activeTab] : { value: verText, isError: false, isVisible: true }
            }))
        }

        let eduOtherFields = education?.checksDetails[activeTab]?.fields['university_board_other'];
        if(eduOtherFields?.field_value && !otherUniv[activeTab]?.isVisible){
          setOtherUniv((prev) => ({
            ...prev,
            [activeTab] : { value: eduOtherFields.field_value, isError: false, isVisible: true }
          }))
        }

        let countryField = education?.checksDetails[activeTab]?.fields['edu_institue_country'];
        if(countryField?.field_value){
          setShowCountry((prev) => ({
            ...prev,
          [activeTab]: countryField.field_value == 'india' ? 0 : 1,
        }));
      }

    }
    // console.log(activeTab, 'tab');
  },[education, activeTab])

  //on intial load  set data for editing in first tab
  useEffect(() => {
    if (
      typeof education.checksDetails !== "undefined" &&
      education.checksDetails !== null
    ) {
      //here find index of the tab with caseCheckId
      //finding which tab is active
      let foundIndex = null;
      var tabs = document.getElementsByClassName("nav-link tab");
      for (let i = 0; i < tabs.length; i++) {
        if (tabs[i].classList.contains("active")) {
          const dataCaseCh = tabs[i].dataset.casecheckid;
          if (dataCaseCh == active) {
            foundIndex = tabs[i].dataset.index;
          }
        }
      }
      let verName = education?.checksDetails[activeTab]?.verificationName;
      let verSource = education?.checksDetails[activeTab]?.verification_source_id;
      let verText = education?.checksDetails[activeTab]?.verification_source_name;
      let collegeVal = education?.checksDetails[activeTab]?.fields[`verificationName_${education?.checksDetails[activeTab]?.case_check_id}`].value;
      let value_elements = document.getElementById("cis_" + education?.checksDetails[activeTab].case_check_id)?.value.trim();

      if(verName && verText && collegeVal == 'other' && (value_elements == 'other' || value_elements == 'Other')){
        setOtherInstituteObj((prev) => ({
            ...prev,
            [activeTab] : { value: verText, isError: false, isVisible: true }
          }))
      }else if(value_elements != 'other' && value_elements != 'Other'){
        setOtherInstituteObj((prev) => ({
          ...prev,
          [activeTab] : { value: '', isError: false, isVisible: false }
        }))
      }

      let eduOtherFields = education?.checksDetails[activeTab]?.fields['university_board_other'];
      if(eduOtherFields?.field_value && !otherUniv[activeTab]?.isVisible){
        setOtherUniv((prev) => ({
          ...prev,
          [activeTab] : { value: eduOtherFields.field_value, isError: false, isVisible: true }
        }))
      }

      // alert(foundIndex);
      if (active !== null && active !== undefined && foundIndex !== null) {
        tabChange(foundIndex, active);
      }
    }
  }, [education, active]);

  //form validation logic
  const formValidation = (caseCheckId, activeTabIndex) => {
    const errors = {};
    let isError = false;

    // resetting all errors first
    var cols = document.getElementsByClassName("err text-danger");
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = "";
    }

    let activeTab = activeTabIndex - 1;

    let case_check_id = education.checksDetails[activeTab].case_check_id;

    let field_education_country =
      education.checksDetails[activeTab].fields.edu_institue_country;

    //checking if filed coming from api is mandatory
    if (field_education_country.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_education_country.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "inIndia_" + case_check_id;

      // let value_element = document
      //   .getElementsByName("country_" + case_check_id + "_value")
      //   // [0]
      //   // .value

      //   console.log(value_element);
      let value_element = field_education_country.field_value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_education_state =
      education.checksDetails[activeTab].fields.edu_institue_state;

    //checking if filed coming from api is mandatory
    if (
      field_education_state.is_mandatory == 1 &&
      (field_education_country.field_value != "outside" && !showCountry[activeTab+1] && education?.companyId != '1813')
    ) {
      //getting field id from api data
      let fieldId = field_education_state.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "state_" + case_check_id;

      let value_element = document
        .getElementsByName("state_" + case_check_id + "_value")[0]
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_qualification_degree =
      education.checksDetails[activeTab].fields.qualification_degree;

    //checking if filed coming from api is mandatory
    if (field_qualification_degree.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_qualification_degree.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "qualificationDegree_" + case_check_id;

      let value_element = document
        .getElementsByName("qualificationDegree_" + case_check_id + "_value")[0]
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_course_name =
      education.checksDetails[activeTab].fields.course_name;
    //checking if filed coming from api is mandatory
    if (field_course_name.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_course_name.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "courseName_" + case_check_id;
      let value_element;
      if (education.course_auto_suggest) {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.value?.trim();
      } else {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.innerText?.trim();
      }
      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
      // }
    }

    let field_university_board =
      education.checksDetails[activeTab].fields.university_board;
    //checking if filed coming from api is mandatory
    if (field_university_board.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_university_board.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "universityBoard_" + case_check_id;
      let value_element = document
        .getElementById("universityBoard_" + case_check_id)
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === "" || 
        (value_element != field_university_board.field_value )
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    const cisSlug = "verificationName_" + caseCheckId;
    let field_cis = education.checksDetails[activeTab].fields[cisSlug];

    // let field_qualification_degree = education.checksDetails[activeTab].fields.qualification_degree;

    //checking if filed coming from api is mandatory
    if (field_cis.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_cis.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "cis_" + case_check_id;

      // let value_element = document.getElementsByName('cis_' + case_check_id + "_value")[0].value.trim();
      let value_elements = document
        .getElementById("cis_" + case_check_id)
        .value.trim();
      console.log("fr", value_elements);

      if (
        value_elements === undefined ||
        value_elements === null ||
        value_elements === "" || 
        (value_elements != 'Other' && value_elements != 'other' && value_elements != field_cis.value && value_elements != formVal[`cis_${case_check_id}`] && education?.companyId != '1813' )
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_college_location =
      education.checksDetails[activeTab].fields.college_location;
    //checking if filed coming from api is mandatory
    if (field_college_location.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_college_location.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "location_" + case_check_id;
      let value_element = document
        .getElementById("location_" + case_check_id)
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let roll_no = education.checksDetails[activeTab].fields.roll_no;
    //checking if filed coming from api is mandatory
    if (roll_no.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = roll_no.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "rollNo_" + case_check_id;
      let value_element = document
        .getElementById("rollNo_" + case_check_id)
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_mode_of_qualification =
      education.checksDetails[activeTab].fields.mode_of_qualification;
    //checking if filed coming from api is mandatory
    if (field_mode_of_qualification.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_mode_of_qualification.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "modeOfQualification_" + case_check_id;
      let value_element = document.getElementById(
        "modeOfQualification_" + case_check_id + "_value"
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_batch_start_year =
      education.checksDetails[activeTab].fields.batch_start_year;
    //checking if filed coming from api is mandatory
    if (field_batch_start_year.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_batch_start_year.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "batchStart_" + case_check_id;
      let value_element = document.getElementById(
        "batchStart_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_batch_end_year =
      education.checksDetails[activeTab].fields.end_year;
    //checking if filed coming from api is mandatory
    if (field_batch_end_year.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_batch_end_year.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "batchEnd_" + case_check_id;
      let value_element = document.getElementById(
        "batchEnd_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    // const cisSlug = 'verificationName_' + caseCheckId;
    // let field_cis = education.checksDetails[activeTab].fields[cisSlug];
    // console.log(field_cis);
    // //checking if filed coming from api is mandatory
    // if (field_cis !== undefined && field_cis.is_mandatory == 1) {
    //   //getting field id from api data
    //   let fieldId = field_cis.id;
    //   //identifying which err id element needs to be populated with error
    //   let elementErrorId = 'err_' + case_check_id + '_' + fieldId;
    //   let elementName = 'cis_' + case_check_id;
    //   let elementValue = newValidationRecord[elementName];

    //   if (elementValue === undefined || elementValue === null) {
    //     document.getElementById(elementErrorId).innerHTML = "This field is required.";
    //     isError = true;
    //   }
    // }

    let submitLaterCheckbox = checked;
    // alert(submitLaterCheckbox)

    if (submitLaterCheckbox === false) {
      const MRLRequiredDocs = MRLDocumentData
        ? MRLDocumentData[case_check_id]?.required_documents
        : null;
      let mrlGroupDocNotRequired = false;
      if (MRLRequiredDocs) {
        MRLRequiredDocs.forEach((reqMRLDoc) => {
          let docCount = document.getElementById(
            "document_" + reqMRLDoc.id + "_count_" + case_check_id
          ).value;
          let is_man = document.getElementById(
            "document_" + reqMRLDoc.id + "_count_" + case_check_id
          ).dataset.mandatory;
          if (is_man == 2) {
            if (docCount > 0) {
              mrlGroupDocNotRequired = true;
            }
          }
        });
      }
      if (MRLRequiredDocs) {
        ///MRL Document Validation
        MRLRequiredDocs.forEach((requiredDocument) => {
          let docCount = document.getElementById(
            "document_" + requiredDocument.id + "_count_" + case_check_id
          ).value;
          // let is_man = document.getElementById(
          //   "document_" + requiredDocument.id + "_count_" + case_check_id
          // ).dataset.mandatory;
          let is_man =  requiredDocument?.is_mandatory
          if (docCount <= 0 && is_man == 1) {
            let elementErrorId =
              "err_document_" + requiredDocument.id + "_count_" + case_check_id;

            document.getElementById(elementErrorId).innerHTML =
              "This field is required.";
            isError = true;
          }
          if (is_man == 2) {
            if (docCount <= 0 && !mrlGroupDocNotRequired) {
              let elementErrorId =
                "err_document_" +
                requiredDocument.id +
                "_count_" +
                case_check_id;

              document.getElementById(elementErrorId).innerHTML =
                "This field is required.";
              isError = true;
            }
          }
          if (errorMessage == "true") {
            let elementErrorId =
              "err_document_" + requiredDocument.id + "_count_" + case_check_id;
            document.getElementById(elementErrorId).innerHTML =
              "File format not valid.";
            isError = true;
          }
        });
      } else {
        /// Required document Validation
        education.checksDetails[activeTab].required_documents &&
          Object.entries(
            education.checksDetails[activeTab].required_documents
          ).map(([key, value]) => {
            let docCount = document.getElementById(
              "document_" + value.id + "_count_" + case_check_id
            ).value;
            let is_man = document.getElementById(
              "document_" + value.id + "_count_" + case_check_id
            ).dataset.mandatory;
            if (docCount <= 0 && is_man == 1) {
              let elementErrorId =
                "err_document_" + value.id + "_count_" + case_check_id;
              document.getElementById(elementErrorId).innerHTML =
                "This field is required.";
              isError = true;
            }
            if (errorMessage == "true") {
              let elementErrorId =
                "err_document_" + value.id + "_count_" + case_check_id;
              document.getElementById(elementErrorId).innerHTML =
                "File format not valid.";
              isError = true;
            }
          });
      }

      // let docCount_371 = document.getElementById("document_368_count_" + case_check_id).value;
      // const is_man_371 = document.getElementById("document_368_count_" + case_check_id).dataset.mandatory;

      // if (docCount_371 <= 0 && is_man_371 == 1) {

      //   let elementErrorId = 'err_document_368_count_' + case_check_id;

      //   document.getElementById(elementErrorId).innerHTML = "This field is required.";
      //   isError = true;
      // }

      // let docCount_372 = document.getElementById("document_369_count_" + case_check_id).value;
      // const is_man_372 = document.getElementById("document_369_count_" + case_check_id).dataset.mandatory;

      // if (docCount_372 <= 0 && is_man_372 == 1) {

      //   let elementErrorId = 'err_document_369_count_' + case_check_id;

      //   document.getElementById(elementErrorId).innerHTML = "This field is required.";
      //   isError = true;
      // }

      // let docCount_370 = document.getElementById("document_370_count_" + case_check_id).value;
      // const is_man_370 = document.getElementById("document_370_count_" + case_check_id).dataset.mandatory;
      // if (docCount_370 <= 0 && is_man_370 == 1) {

      //   let elementErrorId = 'err_document_370_count_' + case_check_id;

      //   document.getElementById(elementErrorId).innerHTML = "This field is required.";
      //   isError = true;
      // }
    }

    return isError;
  };

  //form save handler
  const saveHandler = (event, caseCheckId, activetabIndex, isadd = 0) => {
    event.preventDefault();
    // const formData2 = {};
    // formData2.formVal1 = formVal.formVal1;
    console.log(caseCheckId);
    const err = formValidation(caseCheckId, activetabIndex);
    // let err = false;
    // const otherInstituteErr =
    //   otherInstituteObj.isVisible && !otherInstituteObj.value ? true : false;
    // const isValidationPassed = Object.keys(err).length === 0;
    let otherInstituteErr = false;
    if(otherInstituteObj && otherInstituteObj?.[activetabIndex-1]){
      if(otherInstituteObj?.[activetabIndex-1]?.isVisible){
        let value_element = document.getElementById("otheruniversity_" + caseCheckId).value.trim();
        otherInstituteErr=otherInstituteObj?.[activetabIndex-1]?.isVisible && (!otherInstituteObj?.[activetabIndex-1]?.value && !value_element) ? true : false;
      }     
    }
    let otherUnivErr = false;
    if (otherUniv && otherUniv?.[activetabIndex - 1]) {
      if(otherUniv?.[activetabIndex - 1]?.isVisible){
        let value_element = document.getElementById("universityBoardOther_" + caseCheckId).value;
        otherUnivErr =
        otherUniv?.[activetabIndex - 1]?.isVisible &&
        !otherUniv?.[activetabIndex - 1]?.value 
        ? true
        : false;
        // universityBoardOther_${caseCheckId}
        if(otherUniv?.[activetabIndex - 1]?.value != value_element){
          otherUnivErr = true;
        }
      }
    }

    console.log(caseCheckId);
    if (err === true || otherInstituteErr == true || otherUnivErr == true) {
      if (isadd == 1 && err == true) {
        toast.error(`Please fill the current form and click 'Add Education'`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if (otherInstituteErr) {
        const ob = { ...otherInstituteObj };
        ob[activetabIndex - 1].isError = true;
        // errOther_2268143_verificationName_2268143
        let value_element = document.getElementsByName(
          "errOther_" + caseCheckId + "_verificationName_" + caseCheckId
        )[0];
        // .value.trim();
        // if (
        //   value_element === undefined ||
        //   value_element === null ||
        //   value_element === ""
        // ) {
        //   document.getElementById(elementErrorId).innerHTML =
        //     "This field is required.";
        // }
        setOtherInstituteObj(ob);
      }

      if (otherUnivErr && !otherUniv[activetabIndex - 1].isError ) {
        const obj = { ...otherUniv };
        obj[activetabIndex - 1].isError = true;
        setOtherUniv(obj);
      }
      setFormError(err);
      console.log("here 1356")
      // window.scroll({ top: 0, left: 0, behavior: "smooth" });
      setTimeout(()=> {
        handleScroll()
      },1000)
      // useEffect(() => {
      //   if(placeholder == 'Enter other university or college name'){
      //     if(errId){
      //       let ele = document.getElementsByName(errId);
      //       console.log(ele);
      //       ele.innerHTML =  "This field is required.";
      //     }
      //   }
      // },[errId])
    } else {
      let verificationSource;
      let verificationSourceText;

      if(education?.companyId != "1813"){
        verificationSource = document.getElementById(
          "cis_" + caseCheckId + "_value"
        ).value;
        verificationSourceText = document.getElementById(
          "cis_" + caseCheckId
        ).value;
      }

      // if (otherInstituteObj.isVisible) {
      //   verificationSource = null;
      //   verificationSourceText = otherInstituteObj.value;
      //   document.getElementById("cis_" + caseCheckId + "_value").value = null;
      //   document.getElementById("cis_" + caseCheckId).value = otherInstituteObj.value;
      // }

      // const additonalData = {
      //   // "verificationCourse": "4",
      //   verificationName: verificationSourceText,
      //   verificationSource: parseInt(verificationSource),
      //   verificationSourceText: verificationSourceText,
      //   // "otherVerificationSource": ""
      // };

      const additonalData = {
        // "verificationCourse": "4",
        // verificationName: verificationSourceText,
        // verficationName: '0',
        // verificationSource: parseInt(verificationSource),
        // verificationSourceText: verificationSourceText,
        // "otherVerificationSource":
      };
    
      if (verificationSourceText == "other" || verificationSourceText == "Other") {
        let value = document.getElementById(
          "otheruniversity_" + caseCheckId
        ).value;
        let sourceValue = document.getElementById(
          "otheruniversity_" + caseCheckId + "_hiddenvalue"
        )?.nextSibling?.value;

        if (sourceValue && value == otherInstituteObj?.[activetabIndex-1].value) {
          additonalData.verificationName = 1;
          additonalData.verificationSource = parseInt(sourceValue);
          additonalData.verificationSourceText = value;
        } else {
          additonalData.verificationName = 1;
          additonalData.verificationSource = "";
          additonalData.otherVerificationSource = value;
        }
      } else {
        additonalData.verificationName = 0;
        additonalData.verificationSource = parseInt(verificationSource);
        additonalData.verificationSourceText = verificationSourceText;
      }
      let courseID =
        education?.checksDetails?.[activetabIndex - 1]?.fields.course_name
          ?.option_value;

      additonalData.verificationCourse = courseID;

      // sending university id for college search field
      // uniOptionValue[key]

      // if(otherInstituteObj?.[activetabIndex-1]?.value){
      //   additonalData.verificationName = 1;
      //   additonalData.otherVerificationSource = otherInstituteObj?.[activetabIndex-1]?.value;
      //   additonalData.verificationSource = '';
      // }else{
      //   additonalData.verificationName = 0;
      //   additonalData.verificationSource = parseInt(verificationSource);
      // }

      const recordData = {};
      recordData.case_check_id = caseCheckId;

      const obj = {
        group: "education",
        // "13": "12\/2014",
        // "69": "3",
        // "11": "3333",
        // "12": "",
        // "138": "test",
        // "52": "1",
        ...newRecord,
        ...additonalData,
      };
      obj["464"] = "";
      obj['583'] = uniOptionValue[activetabIndex - 1]
      delete obj[`verificationName_${caseCheckId}`];

      // recordData.check_data = { [caseCheckId]: { "group": "education", ...newRecord, ...additonalData } };
      recordData.check_data = { [caseCheckId]: obj };
      console.log(obj);
      dispatch(saveEducation(recordData, isadd, callbackforOtherInstitute));
    }
  };

  const callbackforOtherInstitute = (is_add, data) => {
    // setOtherInstituteObj({ value: "", isError: false, isVisible: false });
    setOtherInstituteObj((prev) => ({
      ...prev,
      [activeTab] : { value: '', isError: false, isVisible: false }
    }))
    if (is_add == 1) {
      dispatch(addEducation());
      setAdd(is_add);
      localStorage.setItem("disableEditDigi", false);
    }
  };

  //setting loader while saving
  const storeEducationSave = useSelector((state) => state.educationSave);
  const {
    educationSaveData,
    loading: saveLoading,
    error: saveError,
  } = storeEducationSave;
  console.log(educationSaveData);
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //  reRenderAgain();
      }
    }
  }, [saveLoading]);

  //redirecting after saving
  useEffect(() => {
    if (
      typeof educationSaveData.reference_number !== "undefined" &&
      educationSaveData.reference_number !== null
    ) {
      dispatch(getData());
      props.reSetData();
      reRenderAgain2();

      setIsLoading(true);

      // const hasNextCheck = educationSaveData.nextCheck != '' ? true : false;
      // // alert(hasNextCheck);
      // if (!hasNextCheck) {
      //   navigate(
      //     `/case-initiation/check-detail/${educationSaveData.reference_number}/${educationSaveData.group.group_id}`
      //   );
      //   dispatch(deleteSaveEducation());
      // } else {
      //   navigate(
      //     `/case-initiation/check-detail/${educationSaveData.reference_number}/${educationSaveData.group}/${educationSaveData.nextCheck}`
      //   );
      //   dispatch(deleteSaveEducation());
      //   window.scrollTo(0, 0)
      // }
      const group = educationSaveData.group
        ? educationSaveData.group.group_id
        : "";
      const hasNextCheck = educationSaveData.nextCheck != "" ? true : false;
      const reference = educationSaveData.reference_number;
      if (!hasNextCheck) {
        if (group == "profile_preview") {
          navigate(`/case-initiation/profile-preview/${reference}`);
          dispatch(deleteSaveEducation());
        } else if (typeof group != "undefined" && group != "") {
          navigate(`/case-initiation/check-detail/${reference}/${group}`);
          dispatch(deleteSaveEducation());
        }
      } else {
        navigate(
          `/case-initiation/check-detail/${reference}/3/${educationSaveData.nextCheck}`
        );
        dispatch(deleteSaveEducation());
        setIsLoading(false);
        window.scrollTo(0, 0);
      }
    }
  }, [educationSaveData, storeEducationSave]);

  // add education click handler
  const handleEducationAddClick = (e, caseCheckId, index) => {
    e.preventDefault();
    setCaseCheckIdAddEdu(caseCheckId);
    setIndexAddEdu(index);
    setShowAddPopup(true);
    //dispatch(addEducation());
  };

  const addEducationStoreData = useSelector((state) => state.educationAdd);
  const {
    educationAddData,
    loading: addLoad,
    error: addError,
  } = addEducationStoreData;
  const [educationAddedState, setEducationAddedState] = useState();

  //after add handler modify existing main state
  useEffect(() => {
    if (
      typeof educationAddData.data !== "undefined" &&
      educationAddData.data !== null
    ) {
      // const newEducation = { ...education };
      // newEducation['checksDetails'][educationAddData.data.checksCount - 1] = educationAddData.data.checksDetails[0];
      // setEducation(newEducation);
      // setEducationAddedState(1);
      // reRenderAgain();
      navigate(
        `/case-initiation/check-detail/${reference}/3/${educationAddData.data.checksDetails[0].case_check_id}`
      );
      reRenderAgain2();
    }
  }, [educationAddData]);

  //on add handler initiate loader
  useEffect(() => {
    if (typeof addLoad !== "undefined" && addLoad !== null) {
      if (addLoad === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        reRenderAgain2();
      }
    }
  }, [educationAddData]);

  const closeRemovePopup = () => {
    setShowRemovePopup(false);
  };

  const proceedRemove = () => {
    if (checkIdToBeRemoved) {
      dispatch(removeEducation(checkIdToBeRemoved, 0 , activeTab,  removeCheckCallback));
      reRenderAgain();
      setCheckIdToBeRemoved(null);
      setShowRemovePopup(false);
    }
  };

  const removeCheckCallback = (tab) => {
    setActiveTab(0);
  }

  //execute call api on remove hanler
  const handleEducationRemoveClick = (e, caseCheckId) => {
    // alert(caseCheckId);
    // setShowModal(1);
    e.preventDefault();
    // dispatch(removeEducation(caseCheckId));
    setCheckIdToBeRemoved(caseCheckId);
    setShowRemovePopup(true);

    // window.location.reload(false);
    //  reRenderAgain();
  };

  // setting loader while saving
  const storeEducationRemove = useSelector((state) => state.educationRemove);
  const {
    educationRemoveData,
    loading: removeLoading,
    error: removeError,
  } = storeEducationRemove;
  useEffect(() => {
    if (typeof removeLoading !== "undefined" && removeLoading !== null) {
      if (removeLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
      }
    }
  }, [removeLoading]);

  //after add handler remove active from all tabs and append it on last
  useEffect(() => {
    if (
      typeof educationRemoveData.case_check_id !== "undefined" &&
      educationRemoveData.case_check_id !== null
    ) {
      dispatch(getData());

      props.reSetData();

      navigate(`/case-initiation/check-detail/${reference}/3`);
      reRenderAgain2();

      // reRenderAgain();
    }
  }, [educationRemoveData, storeEducationRemove]);

  const errorCheck = (data) => {
    console.log(data);
    setErrorMessage(data);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    const currentUrl = window.location.href;
    const [partA, partB] = currentUrl.split("/check-detail/");
    const [reference, route] = partB.split("/");
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  const getQualification = (status) => {
    if (status == 2 || status == 3) {
      return qualificationOptions;
    }
    const arr = education?.filled_qualification_arr || [];
    const f = qualificationOptions.filter((obj) => {
      if (arr.indexOf(obj.value) != -1) {
        return false;
      }
      return true;
    });
    return f || [];
  };

  /**MRL DOC Start */
  const checkDocApi = (payload, caseCheckId) => {
    dispatch(getMRLDocument(payload, caseCheckId))
  };

  useEffect(() => {
    if (MRLDocumentData && uploadedFilesCount) {
      const checksDetails = edu.checksDetails;

      getUploadedFilesCount(checksDetails);
      getDocumentIdMandatory(checksDetails);
    }
    if (uploadedFilesCount) {
      console.log("upload file count...", uploadedFilesCount);
    }
  }, [MRLDocumentData]);

  useEffect(() => {
    return () => {
      dispatch({ type: "MRL_DOCUMENT_RESET" });
    };
  }, []);

  const getMRLDocList = (checksDetails) => {
    Object.entries(checksDetails).forEach(([key, check]) => {
      if (check?.fields?.qualification_degree?.field_value) {
        let verificationSource = document.getElementById(
          "cis_" + check?.case_check_id + "_value"
        );
        checkDocApi(
          {
            verification_type: 1,
            org_id: verificationSource?.value || check?.verification_source_id,
            qualification_type: check?.fields?.qualification_degree?.field_value || "",
            check_id: check?.check_id,
          },
          check.case_check_id
        );
      }
    });
  };

  // new education form functions

  const selectRadioHandler = (value) => {
        var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";

    // alert(JSON.stringify(value));
    if (value[0].value === "outside") {
      setAllInitialDisable((prev) => ({
        ...prev,
        [activeTab] : false
      }))
      setDisableUniv((prev) => ({
        ...prev,
        [activeTab] : false
      }))
      setDisableCollege((prev) => ({
        ...prev,
        [activeTab] : true
      }))
      setShowCountry((prev) => ({
        ...prev,
        [value[0].index]: 1,
      }));
    } else {
      setShowCountry((prev) => ({
        ...prev,
        [value[0].index]: 0,
      }));
      setAllInitialDisable((prev) => ({
        ...prev,
        [activeTab] : false
      }))
      setDisableUniv((prev) => ({
        ...prev,
        [activeTab] : true
      }))
    }

    setStateBasedUniOptions((prev) => ({
      ...prev,
      [value[0].checkdetailsindex]: "",
    }));

    console.log(showCountry, "country");

    //this is state is for the purpose of storing data to the api
    setNewRecord((prevState) => ({
      ...prevState,
      [value[0].fieldId]: value[0].value,
    }));
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));

    // updateEduDetails(
    //   value[0].checkdetailsindex,
    //   value[0].fieldname,
    //   value[0].value
    // );
    let cisSlug =
      "verificationName_" +
      education?.checksDetails[value[0]?.checkdetailsindex]?.case_check_id;

    updateEduStateDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value,
      cisSlug,
      true
    );
    //this is state is for validation purpose
  };

  const stateHandler = (value) => {
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";

    // alert(JSON.stringify(value));
    if (value[0]) {
      // setDisableUniv(false);
      setDisableUniv((prev) => ({
        ...prev,
        [activeTab] : false
      }))
      // setDisableCollege(true);
      setDisableCollege((prev) => ({
        ...prev,
        [activeTab] : true
      }))
      console.log(otherInstituteObj);
      setOtherInstituteObj((prev) => ({
        ...prev,
        [value[0].checkdetailsindex]: {
          value: "",
          isError: false,
          isVisible: false,
        },
      }));
      setOtherUniv((prev) => ({
        ...prev,
        [value[0].checkdetailsindex]: {
          value: "",
          isError: false,
          isVisible: false,
        },
      }));
      // let payload = {
      //   "country_id": 1,
      //   "state_id": value[0].value,
      //   // "university_id": 20026
      // }

      setStateBasedUniOptions((prev) => ({
        ...prev,
        [value[0].checkdetailsindex]: value[0].value,
      }));

      let cisSlug =
        "verificationName_" +
        education?.checksDetails[value[0]?.checkdetailsindex]?.case_check_id;
      updateEduStateDetails(
        value[0].checkdetailsindex,
        value[0].fieldname,
        value[0].selectedLabel,
        cisSlug
      );

      // clearing the university and college
      // updateEduDetails(
      //   value[0].checkdetailsindex,
      //   "university_board",
      //   null
      // );

      // updateEduDetails(
      //   value[0].checkdetailsindex,
      //   cisSlug,
      //   null
      // );

      // dispatch(fetchStateUniversity(payload, value[0].index ,stateUniCallback));
      // dispatch(getMasterUniversityEducation(payload,stateUniCallback));
    }
  };

  const updateEduStateDetails = (
    dataset,
    name,
    value,
    cisSlugName,
    isRadio
  ) => {
    // alert(value);
    let eduDetails = _.cloneDeep(education);

    eduDetails.checksDetails[parseInt(dataset)].fields[name].field_value =
      value;
    // clearing university values
    eduDetails.checksDetails[parseInt(dataset)].fields[
      "university_board"
    ].field_value = "";
    // clearing college values
    eduDetails.checksDetails[parseInt(dataset)].fields[
      cisSlugName
    ].field_value = "";

    // clearing state field
    if (isRadio) {
      eduDetails.checksDetails[parseInt(dataset)].fields[
        "edu_institue_state"
      ].field_value = "";
    }

    console.log("ee", eduDetails);
    setEducation(eduDetails);

    setOtherInstituteObj((prev) => ({
      ...prev,
      [dataset]: { value: "", isError: false, isVisible: false },
    }));
    setOtherUniv((prev) => ({
      ...prev,
      [dataset]: { value: "", isError: false, isVisible: false },
    }));

    // console.log("ee", education);

    // let details = _.cloneDeep(address);
    // if(details.checksDetails[parseInt(dataset)]&&details.checksDetails[parseInt(dataset)].fields){
    // details.checksDetails[parseInt(dataset)].fields[name].field_value = value;
    // console.log("ee", details);
    // setAddress(details);
    // }
  };

  const universityHandler = (value) => {
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";

    // alert(JSON.stringify(value));

    setDisableUniv(false);
    if (value[0]) {
      let payload = {
        country_id: 1,
        state_id: value[0].value,
        // "university_id": 20026
      };

      // dispatch(fetchStateUniversity(payload, stateUniCallback));
      // dispatch(getMasterUniversityEducation(payload,stateUniCallback));
    }

    //this is state is for the purpose of storing data to the api
    // setNewRecord((prevState) => ({
    //   ...prevState,
    //   [value[0].fieldId]: value[0].value,
    // }));
    // //this is state is for the purpose of storing data to the api

    // //this is state is for validation purpose
    // setNewValidationRecord((prevState) => ({
    //   ...prevState,
    //   [value[0].name]: value[0].value,
    // }));

    // updateEduDetails(
    //   value[0].checkdetailsindex,
    //   value[0].fieldname,
    //   value[0].value
    // );
  };

  const stateUniCallback = (data, idx) => {
    // // alert(data?.data);
    // setStateBasedUniOptions((prev) => ({
    //   ...prev,
    //   [idx] : data?.data
    // }))
    // console.log(data?.data);
  };

  const saveHandlerCV = (event, caseCheckId, activetabIndex, isadd = 0) => {
    event.preventDefault();
    // const formData2 = {};
    // formData2.formVal1 = formVal.formVal1;
    console.log(caseCheckId);
    const err = formValidationCV(caseCheckId, activetabIndex);
    
    console.log(caseCheckId);
    if (err === true) {
      if (isadd == 1 && err == true) {
        toast.error(`Please fill the current form and click 'Add Education'`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
  
      setFormError(err);

      // window.scroll({ top: 0, left: 0, behavior: "smooth" });
      setTimeout(()=> {
        handleScroll()
      },500)

    } else {
      const recordData = {};
      recordData.case_check_id = caseCheckId;

      const obj = {
        group: "education",
        ...newRecord,
      };
      delete obj[`verificationName_${caseCheckId}`];

      recordData.check_data = { [caseCheckId]: obj };
      console.log(obj);
      dispatch(saveEducation(recordData, isadd));
    }
  };

  const formValidationCV = (caseCheckId, activeTabIndex) => {
    const errors = {};
    let isError = false;

    // resetting all errors first
    var cols = document.getElementsByClassName("err text-danger");
    for (let i = 0; i < cols.length; i++) {
      cols[i].innerHTML = "";
    }

    let activeTab = activeTabIndex - 1;

    let case_check_id = education.checksDetails[activeTab].case_check_id;

    let field_course_name =
      education.checksDetails[activeTab].fields.course_name;
    //checking if filed coming from api is mandatory
    if (field_course_name.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_course_name.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "courseName_" + case_check_id;
      let value_element;
      if (education.course_auto_suggest) {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.value?.trim();
      } else {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.innerText?.trim();
      }
      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
      // }
    }

    let field_university_board =
      education.checksDetails[activeTab].fields.cv_education_college;
    //checking if filed coming from api is mandatory
    if (field_university_board.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_university_board.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "cvUniversity_" + case_check_id;
      let value_element = document
        .getElementById("cvUniversity_" + case_check_id)
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === "" || 
        (value_element != field_university_board.field_value )
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }


    let field_batch_end_year =
      education.checksDetails[activeTab].fields.year_of_passing;
    //checking if filed coming from api is mandatory
    if (field_batch_end_year.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_batch_end_year.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId;
      let elementName = "batchEnd_" + case_check_id;
      let value_element = document.getElementById(
        "batchEnd_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    

    return isError;
  };


  console.log(otherUniv, "colluni");
  console.log(newRecord, "nr");
  console.log(otherInstituteObj, 'coll')
  console.log(uniOptionValue, 'uniIDMain')
  console.log(showCountry, 'country')

  console.log(disableUniv, 'univ' , disableCollege);
  // console.log(first)

  return (
    <>
      {/* {(loading || loadRS) && <Loader />} */}
      {isLoading && <Loader />}

      {showAddPopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Education"
          description="Are you sure you want to add another Education?"
          proceedHandler={proceedAdd}
          isAdd={true}
          checkStatus={0}
        />
      )}
      {/* {showAddPopup == true && catchIfAnyStatusIsNotCompleted == 1 && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeAddPopup}
          title="Add Education"
          description="Save the existing education, before adding a new one"
          proceedHandler={proceedAdd}
          isAdd={false}
          checkStatus={catchIfAnyStatusIsNotCompleted}
        />
      )} */}

      {showRemovePopup == true && (
        <ConfirmationPopup
          showModalBox={1}
          closePopup={closeRemovePopup}
          title="Remove Education"
          description="Are you sure you want to remove this education?"
          proceedHandler={proceedRemove}
          isAdd={false}
        />
      )}

    { !!(clientId != 78698 || education?.package_id !== 19599) ?
      <>
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {education.checksDetails &&
            Object.entries(education.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;

              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == caseCheckId) {
                  activeClass = "show active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }

              let completeClass = "";
              console.log(caseCheckStatus);
              if (caseCheckStatus === 2 || caseCheckStatus === 3) {
                completeClass = "completed";
              }

              return (
                <li className={`nav-item ${completeClass}`} key={key}>
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`education-tab-${index}`}
                    data-toggle="tab"
                    href={`#education-${index}`}
                    role="tab"
                    aria-controls={`education-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-caseCheckId={caseCheckId}
                    onClick={() => tabChange(key, caseCheckId)}
                  >
                    {(caseCheckStatus === 2 || caseCheckStatus === 3) && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    Education {index}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      <hr />
      <div className="tab-content" id="myTabContent">
        {education.checksDetails &&
          Object.entries(education.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;

            const caseCheckId = _.cloneDeep(value.case_check_id);
            const documentVisibility = value.document_visibility;
            const caseCheckStatus = value.check_status;
            //mapping needs to be checked need fields array here
            const cisSlug = "verificationName_" + caseCheckId;
            // console.log(value.fields[cisSlug]);

            let activeClass = "";
            if (typeof active !== "undefined") {
              console.log(active + index);

              if (active == caseCheckId) {
                activeClass = "show active";
              }

              // if (active == index) {
              //   activeClass = "show active";
              // }
            } else if (index === 1) {
              activeClass = "show active";
            }
             let verficationSourceName ;
             let verficationSourceid = value.verification_source_id;

            if((otherInstituteObj?.[activeTab]?.isVisible || value.verificationName) && value.verification_source_name){
              verficationSourceName = 'Other'
            }else{
              verficationSourceName = value.verification_source_name
            }

            let stateId;
            if (
              value?.fields?.edu_institue_state?.field_value &&
              stateOptionsEducation.length > 0
            ) {
              let id = "";
              stateOptionsEducation.map((option, i) => {
                if (
                  option.label == value?.fields?.edu_institue_state?.field_value
                ) {
                  id = option.value;
                }
                stateId = id;
              });
            }

            // if(value.uploaded_documents != null){
            //   doc371Count = value.uploaded_documents.length;
            // }

            let doc371Count = 0;
            let doc372Count = 0;
            let doc373Count = 0;

            if (value.uploaded_documents != null) {
              const doc371 = value.uploaded_documents.filter(
                (value) => value.document_id === 371
              );

              doc371Count = doc371.length;

              //////////////////////////////////////

              const doc372 = value.uploaded_documents.filter(
                (value) => value.document_id === 372
              );

              doc372Count = doc372.length;

              //////////////////////////////////////

              const doc373 = value.uploaded_documents.filter(
                (value) => value.document_id === 373
              );

              doc373Count = doc373.length;
            }

            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`education-${index}`}
                role="tabpanel"
                aria-labelledby={`education-tab-${index}`}
                key={key}
                ref={eduRef}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">
                  {/* <div style={{marginTop: 0}}>Education-{`${index}`}</div> */}
                  <span className="d-flex custom-row w-100">
                    {edu.is_custom_education == 1 &&
                      Object.keys(education.checksDetails).length == index && (
                        <button
                          className="btn btn-primary add-btn"
                          id="normalEduAddBtn"
                          onClick={(e) =>
                            handleEducationAddClick(e, caseCheckId, index)
                          }
                        >
                          + Add Education
                        </button>
                      )}
                    {edu.is_custom_education == 1 &&
                      index !== 1 &&
                      education?.checksDetails?.[index - 1]?.is_added && (
                        <button
                          className="btn add-btn dlt-btn d-flex justify-content-around align-items-center"
                          style={{
                            height: 40,
                            marginTop: -10,
                            marginBottom: 10,
                            padding: "4px 10px",
                          }}
                          onClick={(e) =>
                            handleEducationRemoveClick(e, caseCheckId)
                          }
                        >
                          <span>
                            <i
                              style={{ color: "#B42318" }}
                              className="far fa-trash-alt mr-2"
                            ></i>
                          </span>{" "}
                          Delete
                        </button>
                      )}
                  </span>
                </div>

                <div className="row">
                  {value.fields.edu_institue_country && education?.companyId != "1813" ? (
                    <RadioEducation
                      caseCheckId={caseCheckId}
                      name={`inIndia_${caseCheckId}`}
                      id={`inIndia_${caseCheckId}`}
                      inputText={selectRadioHandler}
                      key={index}
                      label={value.fields.edu_institue_country.label}
                      fieldId={value.fields.edu_institue_country.id}
                      value={
                        value.fields.edu_institue_country.field_value 
                        // == "india"
                        //   ? "india"
                        //   : "outside"
                        ? value.fields.edu_institue_country.field_value
                        : "india"
                      }
                      isRequired={
                        value?.fields?.edu_institue_country?.is_mandatory
                      }
                      errId={`err_${caseCheckId}_${value?.fields?.edu_institue_country?.id}`}
                      checkDetailsIndex={key}
                      fieldName="edu_institue_country"
                      index={index}
                      // isDisabled={isDisabled}
                    />
                  ) : (
                    <></>
                  )}
                </div>

                <div className="row">
                  {value.fields.edu_institue_state && !showCountry[index-1] ? (
                    // <ABSelect
                    //   type={
                    //     1
                    //   }
                    //   // type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}
                    //   name={`state_${caseCheckId}`}
                    //   id={`state_${caseCheckId}`}
                    //   fieldId={value.fields.university_board.id}
                    //   placeholder="State"
                    //   autoComplete="off"
                    //   options={stateOptionsEducation}
                    //   attachOther={true}
                    //   verificationType={4}
                    //   selectOption={(dt) => {
                    //     console.log("university data...", dt);
                    //     selectHandler(dt);
                    //   }}
                    //   isRequired={1}
                    //   errId={`err_${caseCheckId}_${value.fields.university_board.id}`}
                    //   caseCheckId={caseCheckId}
                    //   returnType="name"
                    //   checkID={value.fields.university_board.check_id}
                    //   value={newRecord[value.fields.university_board.id]}
                    //   hiddenValue={value.fields.university_board.field_value}
                    //   fieldName="State"
                    //   checkDetailsIndex={key}
                    // />
                    <>
                      <EduSimpleSelect
                        type={
                          1
                        } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                        name={`state_${caseCheckId}`}
                        id={`state_${caseCheckId}`}
                        fieldId={value.fields.edu_institue_state.id}
                        placeholder="State"
                        // autoComplete="off"
                        options={stateOptionsEducation}
                        // attachOther={true}
                        // verificationType={6}
                        selectOption={stateHandler}
                        isRequired={1}
                        errId={`err_${caseCheckId}_${value.fields.edu_institue_state.id}`}
                        caseCheckId={caseCheckId}
                        // returnType="name"
                        value={newRecord[value.fields.edu_institue_state.id]}
                        selectedLabel={
                          value.fields.edu_institue_state.field_name
                        }
                        hiddenValue={
                          value.fields.edu_institue_state.field_value
                        }
                        fieldName="edu_institue_state"
                        checkDetailsIndex={key}
                        isDisabled={allInitialDisable[key]}
                      />
                      <p className="err text-danger">{formError.formVal1}</p>
                    </>
                  ) : (
                    <></>
                  )}

                  {value.fields.university_board &&
                  ( !value.fields.edu_institue_state ||
                    value.fields.edu_institue_country.field_value == "outside" || education?.companyId == "1813") ? (
                    //  education?.companyId == "1813" ?
                        <ABTextEdu
                        name={`universityBoard_${caseCheckId}`}
                        id={`universityBoard_${caseCheckId}`}
                        fieldId={value.fields.university_board.id}
                        label={value.fields.university_board.label}
                        isRequired={1}
                        errId={`err_${caseCheckId}_${value.fields.university_board.id}`}
                        inputText={textHandler}
                        value={newRecord[value.fields.university_board.id]}
                        checkDetailsIndex={key}
                        fieldName="university_board"
                        isDisabled={allInitialDisable[key]}
                        />
                      // :
                    // <SearchableDropdown
                    //   type={
                    //     1
                    //   } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                    //   name={`universityBoard_${caseCheckId}`}
                    //   id={`universityBoard_${caseCheckId}`}
                    //   fieldId={value.fields.university_board.id}
                    //   placeholder="University / Board 1"
                    //   autoComplete="off"
                    //   // options={stateBasedUniOptions[index]}
                    //   stateID={stateBasedUniOptions[key] || stateId}
                    //   attachOther={true}
                    //   verificationType={4}
                    //   selectOption={(dt) => {
                    //     console.log("university data...", dt);
                    //     selectHandler(dt);
                    //   }}
                    //   isRequired={1}
                    //   errId={`err_${caseCheckId}_${value.fields.university_board.id}`}
                    //   caseCheckId={caseCheckId}
                    //   returnType="name"
                    //   checkID={value.fields.university_board.check_id}
                    //   value={newRecord[value.fields.university_board.id]}
                    //   hiddenValue={value.fields.university_board.field_value}
                    //   fieldName="university_board"
                    //   checkDetailsIndex={key}
                    //   isDisabled={allInitialDisable[key] || disableUniv[key]}
                    //   stateValue={value.fields.edu_institue_state.field_value}
                    //   countryVal={value.fields.edu_institue_country}
                    // />
                  ) : (
                    <SearchableDropdown
                      type={
                        3
                      } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                      name={`universityBoard_${caseCheckId}`}
                      id={`universityBoard_${caseCheckId}`}
                      fieldId={value.fields.university_board.id}
                      placeholder="University / Board"
                      autoComplete="off"
                      // options={options}
                      // options={stateBasedUniOptions[index]}
                      stateID={stateBasedUniOptions[key] || stateId}
                      attachOther={true}
                      verificationType={4}
                      selectOption={(dt) => {
                        // console.log("university data...", dt);
                        selectHandler(dt);
                      }}
                      isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.university_board.id}`}
                      caseCheckId={caseCheckId}
                      returnType="name"
                      checkID={value.fields.university_board.check_id}
                      value={newRecord[value.fields.university_board.id]}
                      hiddenValue={value.fields.university_board.field_value}
                      fieldName="university_board_generic"
                      // formName='Digilocker'
                      checkDetailsIndex={key}
                      isDisabled={allInitialDisable[key] || disableUniv[key]}
                      stateValue={value.fields.edu_institue_state.field_value}
                      countryVal={value.fields.edu_institue_country.field_value}
                    />
                  )}

                  {otherUniv[key]?.isVisible ? (
                    // <ABTextEdu
                    //     name={`universityBoardOther_${caseCheckId}`}
                    //     id={`universityBoardOther_${caseCheckId}`}
                    //     fieldId={value.fields.university_board_other.id}
                    //     // fieldId="university_board_other"
                    //     // value={newRecord["university_board_other"]}
                    //     label="Other University / Board"
                    //     // isRequired={1}
                    //     isRequired={value.fields?.university_board_other?.is_mandatory}
                    //     errId={`err_${caseCheckId}_university_board_other_${index}`}
                    //     inputText={textHandler}
                    //     // value={value.fields.university_board.}
                    //     checkDetailsIndex={index}
                    //     fieldName="university_board_other"
                    //     // errId={`err_${caseCheckId}_${value.fields.university_board_other.id}`}
                    //     // value={newRecord[fields.university_board_other.id]}
                    //     value={value.fields?.university_board_other?.field_value}
                    //     isDisabled={allInitialDisable}
                    //   />
                    <ABSelect
                      type={
                        3
                      } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                      name={`universityBoardOther_${caseCheckId}`}
                      id={`universityBoardOther_${caseCheckId}`}
                      fieldId={value.fields.university_board.id}
                      placeholder="Other University / Board"
                      autoComplete="off"
                      // options={options}
                      // attachOther={true}
                      verificationType={4}
                      selectOption={(dt) => {
                        console.log("university data...", dt);
                        selectHandler(dt);
                      }}
                      isRequired={1}
                      // errId={`err_${caseCheckId}_${value.fields.university_board.id}`}
                      errId={`err_${caseCheckId}_${value.fields.university_board_other.id}`}
                      caseCheckId={caseCheckId}
                      returnType="name"
                      checkID={value.fields.university_board.check_id}
                      value={value.fields?.university_board_other?.field_value}
                      // value={newRecord[value.fields.university_board.id]}
                      hiddenValue={value.fields.university_board.field_value}
                      fieldName="university_board_other"
                      checkDetailsIndex={key}
                      isDisabled={allInitialDisable[key] || disableUniv[key]}
                      customError={otherUniv[key].isError}
                    />
                  ) : (
                    <></>
                  )}

                  {value.fields[cisSlug] ? (
                    education?.companyId == "1813" ?
                     <ABTextEdu
                        name={`cis_${caseCheckId}`}
                        id={`cis_${caseCheckId}`}
                        fieldId={value.fields[cisSlug].id}
                        label={value.fields[cisSlug].label}
                        isRequired={1}
                        errId={`err_${caseCheckId}_${value.fields[cisSlug].id}`}
                        inputText={textHandler}
                        value={newRecord[value.fields[cisSlug].id]}
                        checkDetailsIndex={key}
                        fieldName={cisSlug}
                        isDisabled={allInitialDisable[key]}
                        />
                    : 
                      <SearchableDropdown
                        type={
                          3
                        } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                        name={`cis_${caseCheckId}`}
                        id={`cis_${caseCheckId}`}
                        placeholder="College / Institute / School"
                        autoComplete="off"
                        isRequired={1}
                        errId={`err_${caseCheckId}_${value.fields[cisSlug].id}`}
                        attachOther={true}
                        //options={options}
                        // stateID={stateBasedUniOptions[index]}
                        stateID={stateBasedUniOptions[key] || stateId}
                        fieldId={value.fields[cisSlug].id}
                        caseCheckId={caseCheckId}
                        verificationType={4}
                        selectOption={(dt) => {
                          selectHandler2(dt);
                          if(dt[0] && dt[0].optionValue && value?.fields?.qualification_degree?.field_value) {
                          checkDocApi(
                            {
                              verification_type: 1,
                              org_id: dt[0].optionValue,
                              qualification_type: value?.fields?.qualification_degree?.field_value,
                              check_id: value.check_id,
                              case_check_id: caseCheckId,
                              delete: 1
                            },
                            caseCheckId
                          );
                          }
                        }}
                        value={verficationSourceName}
                        hiddenValue={verficationSourceid}
                        returnType="name"
                        fieldName={cisSlug}
                        checkDetailsIndex={key}
                        isDisabled={allInitialDisable[key] || disableCollege[key]}
                        stateValue={value.fields.edu_institue_state.field_value}
                        countryVal={
                          value.fields.edu_institue_country.field_value
                        }
                        uniVal={value.fields.university_board.field_value}
                        universityID={uniOptionValue[key]}
                      />
                    
                  ) : (
                    <></>
                  )}

                  {otherInstituteObj[key]?.isVisible ? (
                    <>
                      {" "}
                      <ABSelect
                        type={
                          3
                        } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                        name={`cis_${caseCheckId}`}
                        id={`otheruniversity_${caseCheckId}`}
                        fieldId={value.fields[cisSlug].id}
                        placeholder="Enter other institute or college name"
                        autoComplete="off"
                        // options={options}
                        // attachOther={true}
                        verificationType={4}
                        selectOption={(dt) => {
                          updateOtherInstitute(dt);
                        }}
                        isRequired={1}
                        // errId={`err_${caseCheckId}_${value.fields.university_board.id}`}
                        errId={`errOther_${caseCheckId}_${value.fields[cisSlug].id}`}
                        caseCheckId={caseCheckId}
                        returnType="name"
                        hiddenValue={verficationSourceid}
                        checkID={value.fields.university_board.check_id}
                        value={otherInstituteObj[key]?.value}
                        fieldName={cisSlug}
                        checkDetailsIndex={key}
                        isDisabled={allInitialDisable[key] || disableCollege[key]}
                        errFlag={otherInstituteObj[key].isError}
                        customError={otherInstituteObj[key].isError}

                      />
                      {/* <ABTextEdu
                            name={`cis_${caseCheckId}`}
                            id={`otheruniversity_${caseCheckId}`}
                            fieldId={value.fields[cisSlug].id}
                            label="Enter other university or college name"
                            isRequired={1}
                            errId={`err_${caseCheckId}_${value.fields[cisSlug].id}`}
                            inputText={updateOtherInstitute}
                            value={otherInstituteObj[key]?.value}
                            // checkDetailsIndex={"ab_d"}
                            checkDetailsIndex={key}
                            fieldName={cisSlug}
                            customError={otherInstituteObj[key].isError}
                            isDisabled={allInitialDisable || disableCollege}
                          /> */}
                    </>
                  ) : (
                    ""
                  )}
                </div>

                <div className="row">
                  
                  {/* {
                  otherInstituteObj?.[index]?.isVisible?<> 
                  <ABTextEdu
                    name={`cis_${caseCheckId}`}
                    id={`otheruniversity_${caseCheckId}`}
                    fieldId={fields[cisSlug].id}
                    label="Other university or college name"
                    isRequired={1}
                    errId={`err_${caseCheckId}_${fields[cisSlug].id}`}
                    inputText={updateOtherInstitute}
                    value={otherInstituteObj?.[index]?.value}
                    checkDetailsIndex={'ab_d'}
                    fieldName={cisSlug}
                    customError={otherInstituteObj?.[index]?.isError}
                    index={index}
                    divClass={"col-sm-12 col-md-12 col-lg-4"}
                    isDisabled={allDisabled}
                  />
                  </>:''
                  }     */}
                  {value.fields.qualification_degree ? (
                    <>
                      <EduSimpleSelect
                        type={
                          1
                        } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                        name={`qualificationDegree_${caseCheckId}`}
                        id={`qualificationDegree_${caseCheckId}`}
                        errId={`err_${caseCheckId}_${value.fields.qualification_degree.id}`}
                        placeholder={value.fields.qualification_degree.label}
                        // autoComplete="off"
                        options={getQualification(caseCheckStatus)}
                        // attachOther={true}
                        // verificationType={6}
                        fieldId={value.fields.qualification_degree.id}
                        caseCheckId={caseCheckId}
                        selectOption={(dt) => {
                          selectHandler(dt);
                          let verificationSource = document.getElementById(
                            "cis_" + caseCheckId + "_value"
                          ).value;
                          if(dt[0] && dt[0].value && dt[0].value != value.fields.qualification_degree.field_value){}
                          checkDocApi(
                            {
                              verification_type: 1,
                              org_id: verificationSource || "",
                              qualification_type: dt[0].value,
                              check_id: value.check_id,
                              delete: 1,
                              case_check_id: caseCheckId
                            },
                            caseCheckId
                          );
                        }}
                        isRequired={1}
                        value={newRecord[value.fields.qualification_degree.id]}
                        selectedLabel={
                          value.fields.qualification_degree.field_value
                        }
                        hiddenValue={
                          newRecord[value.fields.qualification_degree.id]
                        }
                        fieldName="qualification_degree"
                        checkDetailsIndex={key}
                        isDisabled={allInitialDisable[key]}

                        // isDisabled={(caseCheckStatus === 2 || caseCheckStatus === 3)&& Object.keys(education.checksDetails).length > 1 &&newRecord[value.fields.qualification_degree.id]}

                        //  {value.fields.is_document_provided.field_value}
                      />
                    </>
                  ) : (
                    <></>
                  )}
                  {value.fields.course_name ? (
                    education.course_auto_suggest ? (
                      <>
                        <ABSelect
                          type={
                            3
                          } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                          name={`courseName_${caseCheckId}`}
                          id={`courseName_${caseCheckId}`}
                          errId={`err_${caseCheckId}_${value.fields.course_name.id}`}
                          placeholder="Course Name"
                          autoComplete="off"
                          // options={options}
                          attachOther={true}
                          verificationType={6}
                          fieldId={value.fields.course_name.id}
                          selectOption={selectHandler}
                          isRequired={1}
                          caseCheckId={caseCheckId}
                          returnType="name"
                          value={newRecord[value.fields.course_name.id]}
                          hiddenValue={value.fields.course_name.field_value}
                          fieldName="course_name"
                          checkDetailsIndex={key}
                          isDisabled={allInitialDisable[key]}
                        />
                      </>
                    ) : (
                      <>
                        <ABSelect
                          type={
                            1
                          } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                          // name="formVal1"
                          // id="formVal1"
                          name={`courseName_${caseCheckId}`}
                          id={`courseName_${caseCheckId}`}
                          errId={`err_${caseCheckId}_${value.fields.course_name.id}`}
                          placeholder="Course Name"
                          autoComplete="off"
                          options={veridficationCourseNameOptions}
                          selectOption={selectHandler}
                          isRequired={1}
                          caseCheckId={caseCheckId}
                          fieldName="course_name"
                          checkDetailsIndex={key}
                          fieldId={value.fields.course_name.id}
                          value={newRecord[value.fields.course_name.id]}
                          isDisabled={allInitialDisable[key]}
                        />
                      </>
                    )
                  ) : (
                    <></>
                  )}
                  {value.fields.course_subject ? (
                    // <div className="col-sm-4 col-md-12 col-xl-4">
                    //   <div className="form-group">
                    //     <div className="floating-label">
                    //       <select defaultValue="" name="course" id="course" className="form-control" onChange={handleFloatingLabels}>
                    //         <option value=""></option>
                    //         <option value="f">f</option>
                    //       </select>
                    //       <label htmlFor="course" className={formData.course && 'focused'}>Course/Subject<sup className="text-danger">*</sup></label>
                    //     </div>
                    //   </div>
                    // </div>
                    <></>
                  ) : (
                    <></>
                  )}
                  {/* </div> */}

                  {/* <div className="row"> */}
                  {value.fields.college_location ? (
                    // <ABTextEdu
                    //   name={`location_${caseCheckId}`}
                    //   id={`location_${caseCheckId}`}
                    //   fieldId={value.fields.college_location.id}
                    //   label="Location"
                    //   isRequired={1}
                    //   errId={`err_${caseCheckId}_${value.fields.college_location.id}`}
                    //   inputText={textHandler}
                    //   value={newRecord[value.fields.college_location.id]}
                    //   checkDetailsIndex={key}
                    //   fieldName="college_location"
                    //   isDisabled={allInitialDisable[key]}
                    // />
                      <ABSelectEduLocation
                          type={
                            3
                          } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                          name={`location_${caseCheckId}`}
                          id={`location_${caseCheckId}`}
                          placeholder="Location"
                          autoComplete="off"
                          isRequired={1}
                          errId={`err_${caseCheckId}_${value.fields.college_location.id}`}
                          fieldId={value.fields.college_location.id}
                          caseCheckId={caseCheckId}
                          selectOption={selectHandler}
                          value={newRecord[value.fields.college_location.id]}
                          hiddenValue={newRecord[value.fields.college_location.id]}
                          returnType="name"
                          fieldName={"college_location"}
                          checkDetailsIndex={key}
                          isDisabled={allInitialDisable[key]}
                        />
                  ) : (
                    <></>
                  )}
                  {value.fields.mode_of_qualification ? (
                    <>
                      <EduSimpleSelect
                        type={
                          1
                        } /* type=1,2,3 {1 = simple dropdown, 2 = searchable dropdown, 3 = auto-suggest}*/
                        name={`modeOfQualification_${caseCheckId}`}
                        id={`modeOfQualification_${caseCheckId}`}
                        fieldId={value.fields.mode_of_qualification.id}
                        placeholder="Mode Of Qualification"
                        // autoComplete="off"
                        options={modeOfQualificationOptions}
                        // attachOther={true}
                        // verificationType={6}
                        selectOption={selectHandler}
                        isRequired={1}
                        errId={`err_${caseCheckId}_${value.fields.mode_of_qualification.id}`}
                        caseCheckId={caseCheckId}
                        // returnType="name"
                        value={newRecord[value.fields.mode_of_qualification.id]}
                        selectedLabel={
                          value.fields.mode_of_qualification.field_name
                        }
                        hiddenValue={
                          value.fields.mode_of_qualification.field_value
                        }
                        fieldName="mode_of_qualification"
                        checkDetailsIndex={key}
                        isDisabled={allInitialDisable[key]}
                      />
                      <p className="err text-danger">{formError.formVal1}</p>
                    </>
                  ) : (
                    <></>
                  )}
                  {value.fields.roll_no && education.clientId != 387715 ? (
                    <ABTextEdu
                      name={`rollNo_${caseCheckId}`}
                      id={`rollNo_${caseCheckId}`}
                      fieldId={value.fields.roll_no.id}
                      label="Roll Number"
                      isRequired={value?.fields?.roll_no?.is_mandatory}
                      errId={`err_${caseCheckId}_${value.fields.roll_no.id}`}
                      inputText={textHandler}
                      value={newRecord[value.fields.roll_no.id]}
                      checkDetailsIndex={key}
                      fieldName="roll_no"
                      isDisabled={allInitialDisable[key]}
                    />
                  ) : (
                    <></>
                  )}
                  {value.fields.grade_percentage &&
                  education.clientId != 387715 ? (
                    <ABTextEdu
                      name={`grade_${caseCheckId}`}
                      id={`grade_${caseCheckId}`}
                      fieldId={value.fields.grade_percentage.id}
                      label="CGPA/Percentage/Grade"
                      // isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.grade_percentage.id}`}
                      inputText={textHandler}
                      value={newRecord[value.fields.grade_percentage.id]}
                      checkDetailsIndex={key}
                      fieldName="grade_percentage"
                      isDisabled={allInitialDisable[key]}
                    />
                  ) : (
                    <></>
                  )}
                  {/* </div> */}

                  {/* <div className="row"> */}
                  {value.fields.batch_start_year ? (
                    <ABMonthYear
                      // paramStartDate={
                      //   new Date()
                      // }

                      paramStartDate={value.fields.batch_start_year.field_value}
                      //   new Date(
                      //     dateFormat2(
                      //       "MM/YYYY",
                      //       value.fields.batch_start_year.field_value
                      //     )
                      //   )
                      // }

                      // paramStartDate={null}
                      placeholder="Start Date"
                      name={`batchStart_${caseCheckId}`}
                      id={`batchStart_${caseCheckId}`}
                      fieldId={value.fields.batch_start_year.id}
                      isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.batch_start_year.id}`}
                      intialStatus={0}
                      dateSelect={selectHandler}
                      //   maxDate={maxDate}
                      maxDate={newRecord[value.fields.end_year.id]}
                      minimumDate={localStorage.getItem('dob') || ""}
                      checkDetailsIndex={key}
                      fieldName="batch_start_year"
                      isDisabled={allInitialDisable[key]}

                      // dateSelect={(date) => {
                      //processConfirmationDateSelectHandler(date);
                      //     console.log(date)
                      //  }}
                    />
                  ) : (
                    <></>
                  )}

                  {value.fields.end_year ? (
                    <ABMonthYear
                      // paramStartDate={
                      //   new Date()
                      // }
                      paramStartDate={value.fields.end_year.field_value}
                      placeholder="End Date"
                      name={`batchEnd_${caseCheckId}`}
                      id={`batchEnd_${caseCheckId}`}
                      fieldId={value.fields.end_year.id}
                      isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.end_year.id}`}
                      intialStatus={0}
                      dateSelect={selectHandler}
                      minimumDate={newRecord[value.fields.batch_start_year.id]}
                      checkDetailsIndex={key}
                      fieldName="end_year"
                      maxDate="none"
                      isDisabled={allInitialDisable[key]}

                      // dateSelect={(date) => {
                      //processConfirmationDateSelectHandler(date);
                      //     console.log(date)f
                      //  }}
                    />
                  ) : (
                    <></>
                  )}
                  {/* // <div className="row"> */}
                  {value.fields.extra_remarks ? (
                    <ABTextEdu
                      name={`extra_remarks${caseCheckId}`}
                      id={`extra_remarks${caseCheckId}`}
                      fieldId={value.fields.extra_remarks.id}
                      label={value.fields.extra_remarks.label}
                      // isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.extra_remarks.id}`}
                      inputText={selectHandler}
                      value={newRecord[value.fields.extra_remarks.id]}
                      // divClass="col-sm-8 col-md-12 col-xl-8"
                      checkDetailsIndex={key}
                      fieldName="extra_remarks"
                      isDisabled={allInitialDisable[key]}
                    />
                  ) : (
                    <></>
                  )}
                </div>
                {/* </div> */}

                {!allInitialDisable[key] ? (
                  <>
                    {(documentVisibility == 1 ||
                      (MRLDocumentData &&
                        MRLDocumentData[caseCheckId] &&
                        MRLDocumentData[caseCheckId]?.required_documents)) && (
                      <>
                        <p></p>
                        <h6 className="fnt-smi-bld mb-0">Upload File (PDF,PNG,JPG or JPEG with 5 mb Size limit)</h6>
                        {/* <small className="text-muted">Upload one of following : Electricity Bill, Phone Bill, Voter ID , Adhaar Card</small> */}
                        <p></p>
                      </>
                    )}

                    {!!(MRLDocumentData &&
                      MRLDocumentData[caseCheckId] &&
                      MRLDocumentData[caseCheckId]?.required_documents) ?
                      Object.entries(
                        MRLDocumentData[caseCheckId]?.required_documents
                      )?.map(([key, value]) => {
                        return (
                          <>
                            <ABUploadEdu
                              name={value.id}
                              id={value.id}
                              title={value.document_name}
                              record={{
                                caseCheckId:
                                  active !== null && active !== undefined
                                    ? active
                                    : caseCheckId,
                                docId: value.id,
                              }}
                              totalCount={
                                uploadedFilesCount[parseInt(index - 1)] &&
                                uploadedFilesCount[parseInt(index - 1)][
                                  value.id
                                ]
                                  ? uploadedFilesCount[parseInt(index - 1)][
                                      value.id
                                    ]
                                  : 0
                              }
                              // errorCheck={errorCheck}
                              isRequired={
                                documnetMandatory[parseInt(index - 1)][value.id] || !!(value.is_mandatory == 1)
                              }
                              // getCount={doc371Count}
                              reRenderAgain={()=> {}}
                              getUpdatedDocs = {reRenderAgain}
                            />

                            <input
                              type="hidden"
                              name={`document_${value.id}_count_${caseCheckId}`}
                              id={`document_${value.id}_count_${caseCheckId}`}
                              value={
                                uploadedFilesCount[parseInt(index - 1)] &&
                                uploadedFilesCount[parseInt(index - 1)][
                                  value.id
                                ]
                                  ? uploadedFilesCount[parseInt(index - 1)][
                                      value.id
                                    ]
                                  : 0
                              }
                              data-mandatory={
                                documnetMandatory[parseInt(index - 1)][value.id] || !!(value.is_mandatory == 1)
                              }
                            />

                            {!checked ? (
                              <p
                                className="err text-danger"
                                id={`err_document_${value.id}_count_${caseCheckId}`}
                              ></p>
                            ) : (
                              ""
                            )}
                          </>
                        );
                      }) : !!(documentVisibility == 1 && value.required_documents) && 
                      Object.entries(value.required_documents).map(
                        ([key, value]) => {
                          return (
                            <>
                              <ABUploadEdu
                                name={value.id}
                                id={value.id}
                                title={value.document_name}
                                record={{
                                  caseCheckId:
                                    active !== null && active !== undefined
                                      ? active
                                      : caseCheckId,
                                  docId: value.id,
                                }}
                                totalCount={
                                  uploadedFilesCount[parseInt(index - 1)] &&
                                  uploadedFilesCount[parseInt(index - 1)][
                                    value.id
                                  ]
                                    ? uploadedFilesCount[parseInt(index - 1)][
                                        value.id
                                      ]
                                    : 0
                                }
                                // errorCheck={errorCheck}
                                isRequired={
                                  documnetMandatory[parseInt(index - 1)][
                                    value.id
                                  ]
                                }
                                // getCount={doc371Count}
                                reRenderAgain={reRenderAgain}
                              />

                              <input
                                type="hidden"
                                name={`document_${value.id}_count_${caseCheckId}`}
                                id={`document_${value.id}_count_${caseCheckId}`}
                                value={
                                  uploadedFilesCount[parseInt(index - 1)] &&
                                  uploadedFilesCount[parseInt(index - 1)][
                                    value.id
                                  ]
                                    ? uploadedFilesCount[parseInt(index - 1)][
                                        value.id
                                      ]
                                    : 0
                                }
                                data-mandatory={
                                  documnetMandatory[parseInt(index - 1)][
                                    value.id
                                  ]
                                }
                              />

                              {!checked ? (
                                <p
                                  className="err text-danger"
                                  id={`err_document_${value.id}_count_${caseCheckId}`}
                                ></p>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        }
                      )
                    }

                    {
                    // documentVisibility == 1 &&
                    value.fields.is_document_provided &&
                    value.upload_docs_later_checkbox &&
                    value.upload_docs_later_checkbox == 1 ? (
                      <EDUCheckbox
                        name={`submitLater_${caseCheckId}`}
                        id={`submitLater_${caseCheckId}`}
                        fieldId={
                          value.fields.is_document_provided.ibridge_field_id
                        }
                        label={value.fields.is_document_provided.label}
                        isRequired={
                          value.fields.is_document_provided.is_mandatory
                        }
                        errId={`err_${caseCheckId}_${value.fields.is_document_provided.ibridge_field_id}`}
                        // handleCheckboxChange={handleCheckboxChange}
                        handleCheckboxChange={handleChange}
                        checkDetailsIndex={key}
                        fieldName={"is_document_provided"}
                        fieldValue={
                          value.fields.is_document_provided.field_value
                        }
                        // hasError={errorData.till_date}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}

                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) => saveHandler(e, caseCheckId, index)}
                      // disabled={allInitialDisable}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {education.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
      </>
      :
      <>
      <div className="d-flex justify-content-between align-items-center">
        <ul className="nav nav-tabs address-tabs" id="myTab" role="tablist">
          {education.checksDetails &&
            Object.entries(education.checksDetails).map(([key, value]) => {
              const index = parseInt(key) + 1;
              const caseCheckId = value.case_check_id;
              const caseCheckStatus = value.check_status;

              let activeClass = "";
              if (typeof active !== "undefined") {
                if (active == caseCheckId) {
                  activeClass = "show active";
                }
              } else if (index === 1) {
                activeClass = "active";
              }

              let completeClass = "";
              console.log(caseCheckStatus);
              if (caseCheckStatus === 2 || caseCheckStatus === 3) {
                completeClass = "completed";
              }

              return (
                <li className={`nav-item ${completeClass}`} key={key}>
                  <a
                    className={`tab nav-link ${activeClass} ${completeClass}`}
                    id={`education-tab-${index}`}
                    data-toggle="tab"
                    href={`#education-${index}`}
                    role="tab"
                    aria-controls={`education-${index}`}
                    aria-selected="true"
                    data-index={index - 1}
                    data-caseCheckId={caseCheckId}
                    onClick={() => tabChange(key, caseCheckId)}
                  >
                    {(caseCheckStatus === 2 || caseCheckStatus === 3) && (
                      <i class="fas fa-check-circle mr-1"></i>
                    )}
                    Education {index}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
      <hr />
      <div className="tab-content" id="myTabContent">
        {education.checksDetails &&
          Object.entries(education.checksDetails).map(([key, value]) => {
            const index = parseInt(key) + 1;

            const caseCheckId = _.cloneDeep(value.case_check_id);
            const documentVisibility = value.document_visibility;
            const caseCheckStatus = value.check_status;
            //mapping needs to be checked need fields array here
            const cisSlug = "verificationName_" + caseCheckId;
            // console.log(value.fields[cisSlug]);

            let activeClass = "";
            if (typeof active !== "undefined") {
              console.log(active + index);

              if (active == caseCheckId) {
                activeClass = "show active";
              }

              // if (active == index) {
              //   activeClass = "show active";
              // }
            } else if (index === 1) {
              activeClass = "show active";
            }

            return (
              <div
                className={`tab-pane fade ${activeClass}`}
                id={`education-${index}`}
                role="tabpanel"
                aria-labelledby={`education-tab-${index}`}
                key={key}
                ref={eduRef}
              >
                <div className="d-flex justify-content-between align-items-center mb-3">

                </div>

                <div className="row mt-3">
                  {/* university */}
                {value.fields.cv_education_college ? (
                    <ABTextEdu
                      name={`cvUniversity_${caseCheckId}`}
                      id={`cvUniversity_${caseCheckId}`}
                      fieldId={value.fields.cv_education_college.id}
                      label={value.fields.cv_education_college.label}
                      isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.cv_education_college.id}`}
                      inputText={textHandler}
                      value={newRecord[value.fields.cv_education_college.id]}
                      checkDetailsIndex={key}
                      fieldName="cv_education_college"
                      isDisabled={allInitialDisable[key]}
                    />
                  ) : (
                    <></>
                  )}
                    {/* course_name */}
                  {value.fields.course_name ? (
                    <ABTextEdu
                      name={`courseName_${caseCheckId}`}
                      id={`courseName_${caseCheckId}`}
                      fieldId={value.fields.course_name.id}
                      label={value.fields.course_name.label}
                      isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.course_name.id}`}
                      inputText={textHandler}
                      value={newRecord[value.fields.course_name.id]}
                      checkDetailsIndex={key}
                      fieldName="course_name"
                      isDisabled={allInitialDisable[key]}
                    />
                  ) : (
                    <></>
                  )}

                  {/* year_of_passing */}
                  {value.fields.year_of_passing ? (
                    <ABYearEdu
                      // paramStartDate={
                      //   new Date()
                      // }
                      paramStartDate={value.fields.year_of_passing.field_value}
                      placeholder="Year Of Passing"
                      name={`batchEnd_${caseCheckId}`}
                      id={`batchEnd_${caseCheckId}`}
                      fieldId={value.fields.year_of_passing.id}
                      isRequired={1}
                      errId={`err_${caseCheckId}_${value.fields.year_of_passing.id}`}
                      intialStatus={0}
                      dateSelect={selectHandler}
                      // minimumDate={newRecord[value.fields.year_of_passing.id]}
                      checkDetailsIndex={key}
                      fieldName="year_of_passing"
                      maxDate="none"
                      // isDisabled={allInitialDisable[key]}

                      // dateSelect={(date) => {
                      //processConfirmationDateSelectHandler(date);
                      //     console.log(date)f
                      //  }}
                    />
                  ) : (
                    <></>
                  )}
                </div>


                <div className="row mt-3">
                  <div className="col-auto d-flex justify-content-between">
                    <button
                      className="btn btn-primary btn-lg btn-block mt-3"
                      onClick={(e) => saveHandlerCV(e, caseCheckId, index)}
                      // disabled={allInitialDisable}
                    >
                      Save
                    </button>
                  </div>
                </div>
                {education.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-3"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between mt-4">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
      </div>
      </>
    }  
    </>
  );
};
export default MainFormNewEducation;
